import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/路径976@2x.png';
import _imports_1 from '../../../assets/温度@2x.png';
import _imports_2 from '../../../assets/湿度@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-9554d508"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "温区1", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看详情", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  class: "bottom"
};
const _hoisted_7 = {
  class: "group"
};
const _hoisted_8 = {
  class: "group-left"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "空气温度", -1));
const _hoisted_11 = {
  class: "group-right"
};
const _hoisted_12 = {
  class: "group"
};
const _hoisted_13 = {
  class: "group-left"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "空气湿度", -1));
const _hoisted_16 = {
  class: "group-right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_status = _resolveComponent("status");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    class: "look-details",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.lookDetail && $options.lookDetail(...args))
  }, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("span", null, _toDisplayString($options.greenhouseLastestData.airTemperature) + "℃", 1)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_status, {
    value: $options.isTempHeighter,
    optionList: $data.statusOptionList
  }, null, 8, ["value", "optionList"])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createElementVNode("span", null, _toDisplayString($options.greenhouseLastestData.airHumidity) + "%", 1)]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_status, {
    value: $options.isHumHeighter,
    optionList: $data.statusOptionList
  }, null, 8, ["value", "optionList"])])])])]);
}